
export const BOOKMARKS_GET = 'bookmarks/get';
export const OPEN_PROFILE = 'common/open-profile';

export type Action =
	| { type: BOOKMARKS_GET }
    | { type: OPEN_PROFILE };

 


// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/actions/action-types.js